import { render, staticRenderFns } from "./ModalLayoutDefault.vue?vue&type=template&id=6a636743&scoped=true"
import script from "./ModalLayoutDefault.vue?vue&type=script&lang=js"
export * from "./ModalLayoutDefault.vue?vue&type=script&lang=js"
import style0 from "./ModalLayoutDefault.vue?vue&type=style&index=0&id=6a636743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a636743",
  null
  
)

export default component.exports